import React, { FC, memo } from 'react'
import { PhoneSpecsCondensed } from '../../phones'
import { Steps } from '../../state/interfaces'
import { addAnswer, selectFilteredPhonesCondensed, useDispatch, useSelector } from '../../state'
import { SortedPhoneListCondensed } from './sorted-phone-list-condensed'
import { PhoneListCondensed } from './phone-list-condensed'

export const FilteredPhoneListCondensed: FC = memo(() => {
  const phones = useSelector(selectFilteredPhonesCondensed)
  const dispatch = useDispatch()

  const onClick = (phoneId: PhoneSpecsCondensed['phoneId'] | string) => {
    dispatch(addAnswer({ stepId: Steps.PHONE_ID, answerIds: [phoneId.toString()], hidden: true }))
  }

  return <SortedPhoneListCondensed PhoneListCondensed={PhoneListCondensed} phones={phones} onClick={onClick} />
})
